import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { ImageEditorComponent } from '../image-editor/image-editor.component';

@Component({
  selector: 'app-create-images',
  templateUrl: './create-images.component.html',
  styleUrls: ['./create-images.component.css']
})
export class CreateImagesComponent extends GeneralExerciseComponent {

  @ViewChild('imageEditor', {static:true}) imageEditor: ImageEditorComponent;

  requirement: string = "";
  colors: string = "";
  requiredColor: string = "";
  showCompressed: string = "";

  errors: number[][] = [];

  image: string[][];
  cImage: string[][];

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService)
  }

  setTypeSpecificsFromConfiguration() {
    this.colors = this.configuration.typespecifics.colors;
    this.requirement = this.configuration.typespecifics.requirement;
    if (this.requirement.includes('uni')) {
      this.requiredColor = this.requirement.charAt(3);
      this.requirement = "uni";

      switch (this.requiredColor) {
        case "w": this.requiredColor = "white"; break;
        case "k": this.requiredColor = "black"; break;
        case "r": this.requiredColor = "red"; break;
        case "g": this.requiredColor = "green"; break;
        case "b": this.requiredColor = "blue"; break;
      }
    }
    this.showCompressed = this.configuration.typespecifics.showCompressed;
    this.imageEditor.size = 20;
    this.imageEditor.initImage(true);
    this.recomputeImage();
  }

  setTypeSpecificsFromState() {
    if (this.state.typespecific) {
      if (this.state.typespecific.image) {
        this.image = this.state.typespecific.image;
        this.imageEditor.setImage(this.image);
        this.recomputeImage();
      }
    }
    
  }

  computeState() {
    this.state.typespecific.image = this.imageEditor.getImage();
  }

  checkSolution() {
    let firstColor = this.image[0][0];
    //check for more than one color
    if (this.image.map(v => v.filter(u => u != firstColor)).filter(v => v.length != 0).length == 0) {
      this.messageService.addAlertWithTimeout(this.get("doNotUseOneColor"), "danger", 10000);
      return;
    }
    if (this.requirement == 'uni') {
      let temp_errors = this.image.map((v, i) => v.map((u, j) => [u, i, j]).filter(u => this.color(this.cImage[Math.floor(+u[1] / 2)][Math.floor(+u[2] / 2)].toString()) != this.requiredColor).map(u => [Math.floor(+u[1]), Math.floor(+u[2])]));
      this.errors = [].concat(...temp_errors);
      if (this.errors.length > 0) {
        this.messageService.addAlertWithTimeout(this.get("notCorrectYet"), "danger", 10000);
      } else {
        this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
        this.state.solved = true;
        this.solved = true;
        this.saveState();
      }
    } else  /* requirement = create image which can be compressed without loss*/{

      let temp_errors = this.image.map((v, i) => v.map((u, j) => [u, i, j]).filter(u => u[0] != this.cImage[Math.floor(+u[1] / 2)][Math.floor(+u[2] / 2)]).map(u => [+u[1], +u[2]]));
      this.errors = [].concat(...temp_errors);
      if (this.errors.length > 0) {
        this.messageService.addAlertWithTimeout(this.get("notCorrectYet"), "danger", 10000);
      } else {
        this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
        this.state.solved = true;
        this.solved = true;
        this.saveState();
      }
    }
  }

  evaluate(): number[] {
    let points = this.colors == "bw" ? 3 : 5;
    if (this.requirement == 'uni') {
      let temp_errors = this.cImage.map((v, i) => v.map((u, j) => [u, i, j]).filter(u => this.color(u[0].toString()) != this.requiredColor).map(u => [+u[1], +u[2]]));
      let errors = [].concat(...temp_errors);
      return [points * (100 - errors.length) / 100, points];
    } else {
      let temp_errors = this.image.map((v, i) => v.map((u, j) => [u, i, j]).filter(u => u[0] != this.cImage[Math.floor(+u[1] / 2)][Math.floor(+u[2] / 2)]).map(u => [+u[1], +u[2]]));
      let errors = [].concat(...temp_errors);
      return [points * (400 - errors.length) / 400, points];
    }
  }

  /** returns the compression of the the image in imageEditor */
  compressedImage(): string[][] {
    this.image = this.imageEditor.getImage();
    console.log("olle");
    let image = [];
    for (let i = 0; i < 10; i++) {
      let row = [];
      for (let j = 0; j < 10; j++) {
        let square = [];
        square.push(this.image[i * 2][j * 2]);
        square.push(this.image[i * 2 + 1][j * 2]);
        square.push(this.image[i * 2][j * 2 + 1]);
        square.push(this.image[i * 2 + 1][j * 2 + 1]);
        if (this.colors == "bw") {
          square = square.filter(v => v == "k");
          if (square.length >= 2) {
            row.push("k");
          } else {
            row.push("w");
          }
        } else {
          if (square.includes('c') && square.includes('m') && square.includes('y')) {
            row.push("k");
          } else if (square.includes('c') && square.includes('y')) {
            row.push("g");
          } else if (square.includes('c') && square.includes('m')) {
            row.push("b");
          } else if (square.includes('y') && square.includes('m')) {
            row.push("r");
          } else if (square.includes('c')) {
            row.push("c");
          } else if (square.includes('m')) {
            row.push("m");
          } else if (square.includes('y')) {
            row.push("y");
          }

        }
      }
      image.push(row);
    }

    return image;
  }

  /** recomputes the compressed image */
  recomputeImage() {
    this.cImage = this.compressedImage();
  }

  /**returns the expanded name matching the abbreviation of the color */
  color(c: string) {
    switch (c) {
      case "k": return "black";
      case "c": return "cyan";
      case "m": return "magenta";
      case "y": return "yellow";
      case "r": return "red";
      case "g": return "green";
      case "b": return "blue";
      default: return "white";
    }
  }

}
